/**
 * @description 前端机器人上报
 */

import { feBotEndpoint } from '@/config/endpoints';

import { kazeFetch } from '@/utils/kazeFetch';
import { timestampToFormattedTime } from '@/utils/timestampToTime';

type FeBotProps = {
  title: string;
  type: string;
  errorInfo: string;
  uid?: string;
  otherInfo?: string;
};

export class FeBot {
  uid: string = '';
  email: string = '';
  userIdentity: 1 | 2 | 3 = 1;

  setUserId(uid: string) {
    this.uid = uid;
  }

  setEmail(email: string) {
    this.email = email;
  }

  setUserIdentity(userIdentity: 1 | 2 | 3) {
    this.userIdentity = userIdentity;
  }

  async lark_report(props: FeBotProps) {
    const { title, type, errorInfo, uid, otherInfo } = props;
    let content = `type: ${type || window.location.href} \n
    error info: ${errorInfo || ''} \n
    uid:${uid || this.uid || 'not_get_user_id'} \n
    fe_time:${timestampToFormattedTime()}\n`;

    if (otherInfo) {
      content += `other info:${otherInfo}`;
    }

    await kazeFetch(feBotEndpoint, {
      method: 'POST',
      body: JSON.stringify({ title: `${title || 'not_get_title'}`, content }),
    });
  }
}

export const feBot = new FeBot();
